import { Form, FormRule, Input } from "antd";
import * as React from "react";
import { ZodString } from "zod";
import { $ZodCheckMaxLength, $ZodCheckRegex } from "zod/v4/core";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";

/* eslint no-underscore-dangle: ["error", { "allow": ["_zod"] }]  */

type PropsStringEd = {
  node: ZodString;
  path: string[];
  field?: FieldDef;
};

/**
 * Строковое свойство атрибута (н.р. name, title)
 */
export const StringEd: React.FC<PropsStringEd> = (props) => {
  const { node, path, field } = props;
  const rules: FormRule[] = [];
  if (!field?.optional) {
    rules.push({ required: true, message: "Необходимо заполнить поле" });
  }
  let maxLength: number | undefined;
  node.def.checks?.forEach((ch) => {
    if (ch instanceof $ZodCheckRegex) {
      rules.push({
        pattern: ch._zod.def.pattern,
        message: `Требуемый шаблон: ${ch._zod.def.pattern}`,
      });
    } else if (ch instanceof $ZodCheckMaxLength) {
      maxLength = ch._zod.def.maximum;
    }
  });
  return (
    <Form.Item
      name={itemName(path)}
      label={makeLabel(node, path, field)}
      rules={rules}
    >
      <Input
        maxLength={maxLength}
        showCount={!!maxLength}
        allowClear
        title={path.join(".")}
      />
    </Form.Item>
  );
};
